
import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link } from "react-router-dom"
import Button from '../formfields/Button'

type Props = {
  children: any
  fullwidth?: boolean
  id?: string
}


function Card({
  children,
  fullwidth = false,
  id
}: Props) {

  return <div id={id} className={`${fullwidth && 'w-full'} border border border-gray-200 p-4 bg-white rounded shadow flex flex-col gap-2 items-start`}
  >
    {children}
  </div>
}

export default Card